import { Button, Form, Table, Pagination, Input, message } from "antd";
import FullHeightLayout from "../../components/FullHeightLayout";
import { useEffect, useRef, useState } from "react";
import renderFileList from "../../components/renderFileList";
import { checkp } from "../../utils/functions";
import DateInput from "../../components/DateInput";
import ImgUploader from "../../components/ImgUploader";
import CustModal from "../../components/ShowModal";
import useWebPost from "../../utils/useWebPost";


function ZxPtba() {
    const webPost=useWebPost();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [currentItem, setCurrentItem] = useState(null);
    const [data, setData] = useState([]);
    const [form] = Form.useForm();
    const loadingRef = useRef();
    const pageSizeOptions = [20, 50, 100, 500];
    const columns = [
        { title: '序号', dataIndex: 'xd', width: 64, render: (_, __, index) => index + 1 + (page - 1) * pageSize },
        { title: '平台名称', dataIndex: 'name', width: 176 },
        { title: '文件列表', dataIndex: 'files', width: 200, render: (_) => renderFileList(_) },
        { title: '备案日期', dataIndex: 'date1', width: 100 },
        { title: '备案状态', dataIndex: 'status', width: 100 },
        { title: '附件', dataIndex: 'files1', width: 200, render: (_) => renderFileList(_) },
        { title: '备注', dataIndex: 'ps', width: 140 },
        checkp("ptbam") && { title: '操作', dataIndex: 'op', width: 200, render: (_, rs) => <Button type="link" onClick={() => modRecord(rs)}>修改</Button> },
    ].filter(Boolean);
    const modRecord = (rs) => {
        setCurrentItem(rs);
        rs?.id ? form.setFieldsValue(rs) : form.resetFields();
    }
    const onPageChange = (page, size) => {
        let finalPage = page;
        let finalSize = size;
        if (finalSize !== pageSize) {
            finalPage = 1;
            setPageSize(finalSize);
        }
        setPage(finalPage);
        getItems(finalPage, finalSize)
    };

    useEffect(() => {
        getItems(page, pageSize);
    }, [])

    const getItems = async (page, limit) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        try {
            const params = { page, limit };
            webPost('ptbalist', params).then((response) => {
                if (response && response.data) {
                    if (response.total < 1) {
                        message.info('未找到匹配数据');
                    }
                    setData(response.data);
                    setTotal(response.total);
                }
            })
        } catch (e) {
            setData([]);
            setTotal(0);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    const handleOk = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        try {
            const values = await form.validateFields();
            const params = { ...values, id: currentItem?.id };
            webPost('saveptba', params).then((response) => {
                if (response) {
                    message.success("保存成功");
                    getItems(page,pageSize);
                    setCurrentItem(null);
                }
            })
        } catch (e) {
            message.error("保存失败");
        }finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    return (<FullHeightLayout
        headerContent={checkp("ptbam") && <Button type="primary" onClick={() => modRecord({ id: 0 })}>新增平台备案</Button>}
        footerContent={<>
            <div style={{
                display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
            }}>
                <Pagination
                    current={page}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            </div>
        </>}>
        <Table
            columns={columns}
            dataSource={data}
            rowKey="id"
            bordered
            pagination={false}
            scroll={{ x: 'max-content', y: 'calc(100vh - 260px)' }}
            tableLayout="fixed"
            loading={loading}
        />
        <CustModal
            title={currentItem?.id ? '编辑平台备案' : '新增平台备案'}
            open={currentItem !== null}
            onOk={handleOk}
            onCancel={() => setCurrentItem(null)}
            okText="保存"
            width={760}
        >
            <Form form={form} layout="horizontal" labelCol={{span:4}}>
                <Form.Item name="name" label="平台名称"><Input /></Form.Item>
                <Form.Item name="files" label="文件列表"><ImgUploader /></Form.Item>
                <Form.Item name="date1" label="备案日期"><DateInput /></Form.Item>
                <Form.Item name="status" label="备案状态"><Input /></Form.Item>
                <Form.Item name="files1" label="附件"><ImgUploader /></Form.Item>
                <Form.Item name="ps" label="备注"><Input /></Form.Item>
            </Form>
        </CustModal>
    </FullHeightLayout>)
}
export default ZxPtba;